module.exports = __webpack_public_path__ + "img/pdf.dc8e79cf.svg";